// @ts-check

/** @type {import("@liquidweb-dev/club-sauce/public/asset/index.raw").LWApiPublicAssetDetailsParamsRawI['alsowith']} */
const acronisDetailsAlsowith = [
	'featureDetails',
	'acronisBackingUp',
	'product',
	'scheduledCancellationDate',
];

export default acronisDetailsAlsowith;
